module.exports = __webpack_public_path__ + "img/logo-fa-left-gradiant.ffbccfd.svg";